export default {
  name: 'patient-list-detail',
  data() {
    var sortOrders = {}
    var columns = ['patient-name', 'sex', 'birthday', 'age']
    columns.forEach(function(key) {
      sortOrders[key] = 1
    })

    return {
      columns: columns,
      sortKey: '',
      sortOrders: sortOrders
    }
  },
  props: {
    patients: Array
  },
  computed: {
    orderedPatients() {
      var sortKey  = this.sortKey
      var order    = this.sortOrders[sortKey] || 1
      var patients = this.patients
      if (sortKey) {
        patients = patients.slice().sort(function(a, b) {
          if (sortKey === 'patient-name') {
            sortKey = 'patient-name-furigana'
          } else if (sortKey === 'birthday') {
            sortKey = 'sort-birthday'
          }

          a = a.attributes[sortKey]
          b = b.attributes[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return patients
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    }
  },
  methods: {
    sortBy(key) {
      this.sortKey = key
      if ( this.sortOrders[key] > 0) {
        this.sortOrders[key] = -1
      } else {
        this.sortOrders[key] = 1
      }
      console.log('Sorted by ' + key + '.')
    },
    isSortKey(key) {
      return key === this.sortKey
    },
    showMedicineList (idx) {
      var patient = this.orderedPatients[idx]
      this.$store.dispatch('SET_PATIENT', {patient: patient})

      this.$router.push({ path: '/patient/' + patient.id + '/medicines', query: { prev: 'patient_list_detail'}})
    },
    btnColor(key) {
      var btnColor = 'btn-default'
      if (this.isSortKey(key)) {
        btnColor = 'btn-info'
      }

      return btnColor
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/patient-list-detail.js